// Global registry of the currently-focused query editor's context, consumed by
// the floating Object Viewer (Ctrl+F12). The focused editor registers an accessor
// returning { connectionId, database, word } — word is the identifier under the
// cursor (or the trimmed selection). Last focused wins; the viewer polls it.
let accessor = null;

export function registerActiveEditor(fn) { accessor = fn; }
export function clearActiveEditor(fn) { if (accessor === fn) accessor = null; }
export function readActiveEditor() {
  try { return accessor ? accessor() : null; } catch { return null; }
}

// wordAtCursor extracts the identifier under the caret (or the trimmed selection)
// from a CodeMirror EditorView. Backtick/qualifier aware: `db`.`table` or
// db.table with the caret on the last segment yields "table".
export function wordAtCursor(view) {
  if (!view) return '';
  try {
    const sel = view.state.selection.main;
    if (!sel.empty) return view.state.sliceDoc(sel.from, sel.to).trim().replace(/`/g, '');
    const line = view.state.doc.lineAt(sel.head);
    const text = line.text;
    const col = sel.head - line.from;
    const isW = (ch) => ch && /[A-Za-z0-9_$]/.test(ch);
    let s = col, e = col;
    while (s > 0 && isW(text[s - 1])) s--;
    while (e < text.length && isW(text[e])) e++;
    return text.slice(s, e);
  } catch { return ''; }
}
